// Generated at:2024-07-17 09:56:03
export default {
    message: {
        "fail": "бүтэлгүйтсэн",
        "server error..": "Серверийн алдаа.",
        "duplicated request": "давхардсан хүсэлт",
        "invalid request parameter": "хүчингүй хүсэлтийн параметр",
        "missing access token": "хандалтын токен алга",
        "invalid access token": "буруу хандалтын токен",
        "you are forbidden to access the system": "системд нэвтрэхийг хориглоно",
        "you are forbidden to access the api": "та api-д хандахыг хориглоно",
        "BackMyAIS": "Back MyAIS",
        "Home": "Гэр",
        "Product": "Бүтээгдэхүүн",
        "Card": "Карт",
        "DirectTopUp": "Шууд цэнэглэх",
        "MyAccount": "Миний данс",
        "Search": "Хайх",
        "SearchResult": "Хайлтын үр дүн",
        "PopularSearchKeywords": "Түгээмэл хайлтын түлхүүр үгс",
        "AllProducts": "Бүх бүтээгдэхүүн",
        "All": "Бүгд",
        "Filter": "Шүүлтүүр",
        "WeCouldNotFindAnythingPleaseTrySomethingElse": "Бид юу ч олж чадсангүй, өөр зүйл оролдоно уу.",
        "InputTheKeyword": "Бүтээгдэхүүний хайлтын түлхүүр үгээ бичээд хайлт дээр дарна уу.",
        "NoMoreResult": "Өөр үр дүн байхгүй",
        "CardSelected": "Карт сонгосон",
        "SelectCard": "Карт сонгоно уу",
        "TopupAmount": "Цэнэглэх хэмжээ",
        "SelectTopupAmount": "Цэнэглэх дүнг сонгоно уу",
        "StockOut": "Нөөц дуусах",
        "PurchaseQuantity": "Худалдан авалтын тоо",
        "PurchaseLimit": "Худалдан авалтын хязгаар",
        "PaymentChannel": "Төлбөрийн суваг",
        "ProcessingFees": "Боловсруулалтын хураамж",
        "SorryThisPaymentChannelIsTemporarilyUnavailable": "Уучлаарай, энэ төлбөрийн суваг түр хугацаанд боломжгүй байна.",
        "EmailAddress": "Имэйл хаяг",
        "YourE-mailAddress": "Таны и-мэйл хаяг",
        "Description": "Тодорхойлолт",
        "Instruction": "Заавар",
        "OrderInformation": "Захиалгын мэдээлэл",
        "PleaseFillInOrderInformation": "Захиалгын мэдээллийг бөглөнө үү",
        "Confirm": "Баталгаажуулах",
        "PleaseInputYourEmail": "Имэйлээ оруулна уу",
        "PleaseConfirmTheContentsOfYourOrder": "Захиалгааныхаа агуулгыг баталгаажуулна уу",
        "MyOrders": "Миний захиалга",
        "Notification": "Мэдэгдэл",
        "LiveChat": "Шууд чат",
        "RecentPurchases": "Сүүлийн үеийн худалдан авалтууд",
        "WaitSend": "Хүлээж илгээх",
        "Sending": "Илгээж байна",
        "Refunded": "Буцаан олгосон",
        "PartialRefund": "Хэсэгчилсэн буцаан олголт",
        "Closed": "Хаалттай",
        "Completed": "Дууссан",
        "PayNow": "Одоо төл",
        "OrderDetails": "Захиалгын мэдээлэл",
        "OriginalPriceTotal": "Жинхэнэ үнэ",
        "GSTInclusive": "GST багтаасан",
        "Inclusive": "багтаасан",
        "PaymentStatus": "Төлбөрийн төлөв",
        "CreatedOn": "Үүсгэсэн",
        "ExpiredAfter": "Дараа нь хугацаа нь дууссан",
        "Paid": "Төлбөртэй",
        "Total": "Нийт",
        "RetrieveCode": "Код татаж авах",
        "ExpireDate": "Дуусах огноо",
        "ClickToCopyTheTextContentToTheClipboard": "Текстийн агуулгыг санах ой руу хуулахын тулд товшино уу",
        "SendCard": "Худалдан авалтын дэлгэрэнгүй мэдээллийг танд илгээхийн тулд хүчинтэй имэйл хаяг оруулна уу.",
        "SorryThisItemIsUnavailableInYourRegion": "Уучлаарай! Энэ зүйл танай бүс нутагт боломжгүй байна.",
        "FillEailAddress": "Имэйл хаягаа оруулна уу, бид таны худалдан авсан онооны картыг энэ имэйл хаягаар илгээх болно.",
        "Wishlist": "Хүссэн жагсаалт",
        "CantFindWriteWishList": "Танд үзэхийг хүссэн тоглоом байгаа ч энд байхгүй байна уу?",
        "FillOutMyWishList": "Хүслийн жагсаалтыг илгээх",
        "WhatWouldYouLikeToBuyAtTheSEAGMMiniStore": "Үзэхийг бидэнд байгаа одоо энд байхгүй тоглоомоо хэлнэ үү?",
        "WeCollectWishServeYouBetter": "Бид ирээдүйд илүү олон тоглоомыг шинэчлэх болно. Хамт байгаарай.",
        "Send": "Илгээх",
        "OrderLiveChatTips": "Хэрэв танд захиалгатай холбоотой асуудал гарвал онлайн харилцагчийн үйлчилгээтэй холбогдоно уу.",
        "CustomerService": "Харилцагчийн үйлчилгээ",
        "OrderConfirmation": "Захиалга баталгаажилт",
        "MyInvoice": "Миний нэхэмжлэх",
        "Generate": "Үүсгэх",
        "Download": "Татаж авах",
        "GenerateInvoice": "Нэхэмжлэх үүсгэх",
        "DownloadInvoice": "Нэхэмжлэхийг татаж авах",
        "SelectPayment": "Төлбөрийг сонгоно уу",
        "FillInYourInformation": "Мэдээллээ бөглөнө үү",
        "SubmitInvoiceInformation": "Нэхэмжлэхийн мэдээллийг оруулах",
        "NoDownloadInvoice": "Одоогоор татаж авах боломжтой нэхэмжлэх байхгүй байна",
        "NoGenerateInvoice": "Одоогоор нэхэмжлэх захиалга байхгүй байна",
        "RecentlyUsed": "Саяхан ашигласан",
        "InvoiceID": "Нэхэмжлэхийн ID",
        "GeneratedTime": "Үүсгэсэн цаг",
        "PaymentID": "Төлбөрийн ID",
        "GenerateInvoiceTips": "SEAGM цахим нэхэмжлэх: Зөвхөн дууссан төлбөр нь нэхэмжлэх гаргах эрхтэй. Төлбөр бүр зөвхөн нэг удаа цахим нэхэмжлэх үүсгэх боломжтой. Нэхэмжлэх гаргахын тулд татварын мэдээллээ оруулна уу.",
        "Country": "Улс",
        "State": "муж",
        "City": "Хот",
        "CityName": "Хотын нэр",
        "Address": "Хаяг",
        "YourAddress": "Таны хаяг",
        "Identification": "Таних",
        "InputInvoicetype": "Нэхэмжлэхийн төрөлд тохирох утга",
        "IdentificationNumber": "Тодорхойлох дугаар",
        "RequiredIdentificationNumber": "Малайзын хэрэглэгчийн хувьд TIN дугаараа зөв оруулна уу, Малайзын бус хэрэглэгч бол өгөгдмөл TIN дугаар EI00000000010 ашиглана уу.",
        "PassportName": "Паспортын нэр",
        "RequiredBRN": "Бизнесийн бүртгэлийн зөв дугаар",
        "RequiredArmy": "Малайзын хувь хүний ​​хувьд: MyKad / MyTentera таних дугаар, Малайзын бус хувь хүний ​​хувьд: MyPR / MyKAS таних дугаар",
        "Name": "Нэр",
        "Company": "Компани",
        "YourName": "Таны нэр",
        "CompanyName": "Компанийн нэр",
        "TinNumber": "Цагаан тугалганы дугаар",
        "MandatoryMalaysians": "Энэ нь Малайзчууд болон компаниудад заавал байх ёстой.",
        "RequiredSST": "Хэрэв та SST-д бүртгүүлсэн бол шаардлагатай. Жишээ нь: B01-xxxx-xxxxxxxx",
        "PhoneNumber": "Утас",
        "YourContactNumber": "Таны холбоо барих дугаар",
        "Email": "Имэйл",
        "YourEmail": "Таны имэйл",
        "IFNotApplicable": "Боломжгүй бол хоосон орхино уу.",
        "PleaseInputCityName": "Хотын нэрийг оруулна уу",
        "PleaseInputYourName": "Нэрээ оруулна уу",
        "PleaseInputIdentify": "Тодорхойлолтыг оруулна уу",
        "PleaseInputTin": "Цагаан тугалга оруулна уу",
        "PleaseInputAddress": "Хаяг оруулна уу",
        "PleaseInputContactNumber": "Холбоо барих дугаараа оруулна уу",
        "PleaseSelectPayment": "Төлбөрийг сонгоно уу",
        "CantDownLoadInvoice": "Хэрэв та нэхэмжлэхийг татаж авах боломжгүй бол. Нэхэмжлэхийг татахын тулд дараах хаягийг хуулж хөтчөөсөө нээнэ үү.",
        "CopyURL": "Url хуулах",
        "Close": "Хаах",
        "CopySuccess": "Амжилттай хуулах",
        "CopyFail": "Хуулбаргүй",
        "NRICNumber": "NRIC дугаар нь 12 оронтой тоо байх ёстой"
    }
}